import { create } from 'zustand';
import { BASE_URL } from '@/config/api';

export interface StoredAccount {
  id: string;
  token: string;
  firstname: string;
  lastname: string;
  email: string;
  account_type: string;
  image_url?: string;
  school_name?: string;
  roleType?: string;
}

interface AccountStore {
  accounts: StoredAccount[];
  addAccount: (account: StoredAccount) => void;
  removeAccount: (id: string) => void;
  getAccounts: () => StoredAccount[];
  syncCurrentUser: (user: any, token: string) => void;
  clear: () => void;
}

const STORAGE_KEY = 'sportlogin-accounts';

const loadAccounts = (): StoredAccount[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

const saveAccounts = (accounts: StoredAccount[]) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(accounts));
};

export const useAccountStore = create<AccountStore>((set, get) => ({
  accounts: loadAccounts(),

  addAccount: (account) => {
    const current = get().accounts.filter(a => a.id !== account.id);
    const updated = [...current, account];
    saveAccounts(updated);
    set({ accounts: updated });
  },

  removeAccount: (id) => {
    const updated = get().accounts.filter(a => a.id !== id);
    saveAccounts(updated);
    set({ accounts: updated });
  },

  getAccounts: () => get().accounts,

  syncCurrentUser: (user, token) => {
    if (!user || !token) return;
    const account: StoredAccount = {
      id: user.id || user.userId,
      token,
      firstname: user.firstname,
      lastname: user.lastname,
      email: user.email,
      account_type: user.account_type,
      image_url: user.image_url,
      school_name: user.school_name,
      roleType: user.roleType,
    };
    get().addAccount(account);
  },

  clear: () => {
    localStorage.removeItem(STORAGE_KEY);
    set({ accounts: [] });
  },
}));
